/* Consulta NFS: notas capturadas do ADN (backend /nfse-captura) */
import { apiFetch, API_URL, obterToken } from './apiClient';

const B = '/nfse-captura';
const qs = (p) => {
  const u = new URLSearchParams();
  Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') u.set(k, v); });
  const s = u.toString();
  return s ? `?${s}` : '';
};

export const listarClientesCaptura = () => apiFetch(`${B}/clientes`);
export const listarPendenciasCaptura = () => apiFetch(`${B}/pendencias`);
export const listarNotasCapturadas = (filtro) => apiFetch(`${B}/notas${qs(filtro)}`);
export const listarExecucoesCaptura = (clienteId) => apiFetch(`${B}/execucoes${qs({ cliente_id: clienteId })}`);
export const sincronizarClienteCaptura = (id) => apiFetch(`${B}/clientes/${id}/sincronizar`, { method: 'POST' });
export const executarCapturaTodos = () => apiFetch(`${B}/executar`, { method: 'POST' });
export const executarPaulistana = () => apiFetch(`${B}/paulistana/executar`, { method: 'POST' });
export const analisarSequencia = (filtro) => apiFetch(`${B}/sequencia${qs(filtro)}`);
export const justificarSequencia = (corpo) => apiFetch(`${B}/sequencia/justificar`, { method: 'POST', body: JSON.stringify(corpo) });
export const removerJustificativa = (id) => apiFetch(`${B}/sequencia/justificar/${id}`, { method: 'DELETE' });
/* ZIP do filtro (XML + PDF) arquivado no Docs, na pasta do cliente */
export const enviarZipDocs = (filtro) => apiFetch(`${B}/docs${qs(filtro)}`, { method: 'POST' });

/* download autenticado (XML, PDF ou ZIP do filtro) */
export async function baixarCaptura(caminho, nomePadrao, abrir = false) {
  const nova = abrir ? window.open('', '_blank') : null;
  const token = obterToken();
  const r = await fetch(`${API_URL}${B}${caminho}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) {
    if (nova) nova.close();
    let msg = 'Erro ao baixar o arquivo';
    try { msg = (await r.json()).error || msg; } catch { /* sem JSON */ }
    throw new Error(msg);
  }
  const nome = (/filename="([^"]+)"/.exec(r.headers.get('content-disposition') || '') || [])[1] || nomePadrao;
  const url = URL.createObjectURL(await r.blob());
  if (nova) { nova.location.href = url; return; }
  const a = document.createElement('a');
  a.href = url; a.download = nome;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
export const urlZip = (filtro) => `/zip${qs(filtro)}`;

/* arquivo autenticado como URL local (blob), pra abrir dentro do sistema */
export async function arquivoCaptura(caminho) {
  const token = obterToken();
  const r = await fetch(`${API_URL}${B}${caminho}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) {
    let msg = 'Erro ao abrir o arquivo';
    try { msg = (await r.json()).error || msg; } catch { /* sem JSON */ }
    throw new Error(msg);
  }
  const nome = (/filename="([^"]+)"/.exec(r.headers.get('content-disposition') || '') || [])[1] || 'arquivo';
  return { url: URL.createObjectURL(await r.blob()), nome };
}
